import {
  V2Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  VisuallyHidden,
  DialogDescription,
} from "web-design-system";
import { useState } from "react";
import { useRouter, getRouteApi } from "@tanstack/react-router";
import { omit } from "lodash";
import { Client } from "creso-core/types";
import { MfCentralImport } from "web-core/components";
import { CasUpload } from "./cas-upload";

export type ImportType = "mfcentral" | "cas" | "mfcentral-v2";

export function ImportHoldingsDialogContent({
  client,
  onClose,
}: {
  client: Client;
  onClose: () => void;
}) {
  const [importType, setImportType] = useState<ImportType>("mfcentral");

  return (
    <V2Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="flex flex-col p-0 gap-0 min-h-100 max-h-none max-w-none w-fit overflow-hidden">
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle>Import holdings dialog</DialogTitle>
            <DialogDescription>Import holdings dialog</DialogDescription>
          </DialogHeader>
        </VisuallyHidden>
        {importType === "mfcentral" ? (
          <MfCentralImport
            client={client}
            onClose={onClose}
            onImportViaCas={() => setImportType("cas")}
          />
        ) : (
          <CasUpload onChangeImportType={setImportType} client={client} />
        )}
      </DialogContent>
    </V2Dialog>
  );
}

export function ImportHoldingsDialog() {
  const route = getRouteApi("/(auth)/_headed/clients/$id");
  const { client } = route.useLoaderData();
  const router = useRouter();

  return (
    <ImportHoldingsDialogContent
      client={client}
      onClose={() =>
        router.navigate({
          to: ".",
          search: (prev) => omit(prev, ["modal"]),
          replace: true,
        })
      }
    />
  );
}
